module.exports = __webpack_public_path__ + "img/qx50-25.156fe5c1.png";